import styled, { keyframes, css } from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const slideInDown = keyframes`
	0% {
		transform: translate3d(0, -100%, 0);
		visibility: visible;
		height: 0;
	}

	100% {
		transform: translate3d(0, 0, 0);
		height: 48px;
	}
`;

const isIn = status => status === 'entered' || status === 'exited';
export const Banner = styled.div`
	background-color: ${getColor('lavender')};
	color: ${getColor('white')};
	cursor: ${props => props.dismissable ? 'pointer' : 'inherit'};
	font-size: 16px;
	animation: 250ms ${slideInDown} ease-out;
	transition: 250ms;
	height: 48px;

	${({ status } ) => !isIn(status) && css`
		height: 0;
	`}

	&:hover, &:active {
		transition-duration: .2s;
		background-color: ${props => props.dismissable ? getColor('blueBell') : getColor('lavender')};
	}

	@media(max-width: 375px) {
		font-size: 11px;
	}
`;

export const Message = styled.h6`
	margin: 0;
	margin-left: auto;
	margin-right: auto;
	font-size: 1em;
	margin-bottom: 4px;

	@media(max-width: 375px) {
		font-weight: 700;
		margin-bottom: 0;
	}
	> p {
		margin-bottom: 0;
	}
`;

export const Flex = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 48px;
`;

const desktopIconSize = `1.1em`;
const mobileIconSize = `1em`;
export const IconWrapper = styled.div`
	min-width: ${desktopIconSize};
	flex-basis: ${desktopIconSize};

	svg {
		width: ${desktopIconSize};
		height: ${desktopIconSize};
		fill: currentColor;

		@media(max-width: 375px) {
			width: ${mobileIconSize};
			height: ${mobileIconSize};
		}

	}

	@media(max-width: 375px) {
		min-width: ${mobileIconSize};
		flex-basis: ${mobileIconSize};
	}
`;
